<template>
<router-view class="view"></router-view>
</template>

<script>
export default {
    name: 'app',
    data: function() {
        return {}
    }
}
</script>

<style lang="less">

</style>



// WEBPACK FOOTER //
// App.vue?3fd775ce